import { useMemo } from 'react';
import type { ODataGridColumn } from '@inuxe/prime-odata-grid';
import type { IOvertimeResult } from '../../../models/overtime/OvertimeModel';
import OvertimeManagementActionCell from './parts/OvertimeManagementActionCell';
import OvertimeStatusCell from './parts/OvertimeStatusCell';

export function useOvertimeManagementColumns(
  showStatusColumn: boolean
): ODataGridColumn<IOvertimeResult>[] {
  return useMemo<ODataGridColumn<IOvertimeResult>[]>(
    () => [
      {
        id: 'actions',
        header: 'İşlemler',
        sortable: false,
        filter: false,
        width: 160,
        className: 'grid-action-column',
        actionSticky: 'left',
        body: row => <OvertimeManagementActionCell row={row} />,
      },
      {
        field: 'id',
        header: 'ID',
        dataType: 'numeric',
        width: 80,
        sortable: true,
        filter: true,
      },
      {
        field: 'userName',
        header: 'Kullanıcı',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
      {
        field: 'startDate',
        header: 'Başlangıç Tarihi',
        dataType: 'date',
        minWidth: 150,
        sortable: true,
        filter: true,
        body: row =>
          row.startDate
            ? new Date(row.startDate).toLocaleString('tr-TR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              })
            : '',
      },
      {
        field: 'endDate',
        header: 'Bitiş Tarihi',
        dataType: 'date',
        minWidth: 150,
        sortable: true,
        filter: true,
        body: row =>
          row.endDate
            ? new Date(row.endDate).toLocaleString('tr-TR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              })
            : '',
      },
      {
        field: 'totalHours',
        header: 'Toplam Saat',
        dataType: 'numeric',
        width: 120,
        sortable: true,
        filter: true,
      },
      {
        field: 'description',
        header: 'Açıklama',
        minWidth: 200,
        sortable: true,
        filter: true,
      },
      {
        field: 'overtimeType',
        header: 'Tür',
        width: 100,
        sortable: true,
        filter: true,
        body: row => (row.overtimeType === 'Overtime' ? 'Mesai' : 'İzin'),
      },
      {
        field: 'status',
        header: 'Durum',
        width: 120,
        sortable: true,
        filter: true,
        hidden: !showStatusColumn,
        body: row => <OvertimeStatusCell row={row} />,
      },
      {
        field: 'createdDate',
        header: 'Oluşturulma Tarihi',
        dataType: 'date',
        minWidth: 160,
        sortable: true,
        filter: true,
        body: row =>
          row.createdDate ? new Date(row.createdDate).toLocaleDateString('tr-TR') : '',
      },
      {
        field: 'approvedBy',
        header: 'Onaylayan/Reddeden',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
    ],
    [showStatusColumn]
  );
}
